import { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Scale } from "lucide-react";
import { getFatherVerdict } from "@/lib/api";
import { InfoHint } from "@/components/InfoHint";

const fmt = (v) => (v == null ? "—" : v > 0 ? `+${v.toFixed(2)}` : v.toFixed(2));
const cls = (v) => (v > 0 ? "text-emerald-300" : v < 0 ? "text-rose-300" : "text-white/40");
const V = {
  guadagna: "border-emerald-500/50 text-emerald-300",
  perde: "border-rose-500/50 text-rose-300",
  "dipende da un trade": "border-amber-500/50 text-amber-300",
  "campione corto": "border-white/25 text-white/50",
};

export const FatherVerdictBlock = () => {
  const [d, setD] = useState(null);
  useEffect(() => { getFatherVerdict().then(setD).catch(() => {}); }, []);
  if (!d?.fathers?.length) return null;
  return (
    <div className="rounded-md border border-border/60 bg-background/40 p-2.5 space-y-2"
      data-testid="father-verdict-block">
      <div className="flex flex-wrap items-center gap-2">
        <Scale className="h-3.5 w-3.5 text-sky-300" />
        <span className="text-[11px] uppercase tracking-wide text-muted-foreground">
          Verdetto per padre · col pedaggio dentro
        </span>
        <InfoHint testId="info-father-verdict" text={d.rule} />
        <span className={`ml-auto font-mono text-[11px] ${cls(d.net)}`}
          data-testid="father-verdict-total">
          {Object.entries(d.totalsByCurrency || {}).map(([ccy, value]) => `${fmt(value)} ${ccy}`).join(" · ")} · {d.n} chiusure
        </span>
      </div>

      {d.fathers.map((f) => (
        <div key={f.key || f.father} className="border-t border-border/40 pt-1.5"
          data-testid={`father-verdict-${f.father}-${f.currency}`}>
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-[11px] text-white/80">{f.label}</span>
            <Badge variant="outline" className={`text-[10px] ${V[f.verdict] || V["campione corto"]}`}>
              {f.verdict}
            </Badge>
            <span className="ml-auto font-mono text-[10.5px] text-white/50">
              n {f.n} · netto <span data-testid={`father-net-${f.key}`} className={cls(f.net)}>{fmt(f.net)} {f.currency}</span> · senza il
              migliore <span data-testid={`father-net-ex-top-${f.key}`} className={cls(f.netExTop)}>{fmt(f.netExTop)} {f.currency}</span> · vinti {f.winRate}%
              {f.feesPaid > 0 ? ` · fee registrate ${f.feesPaid.toFixed(2)} ${f.currency}` : ""}
            </span>
          </div>
          <p className="mt-0.5 text-[10px] leading-snug text-white/40">
            {f.why} · {f.platforms.join(", ")} · {f.from}→{f.to}
          </p>
        </div>
      ))}

      <p className="text-[10px] leading-snug text-amber-300/70" data-testid="father-verdict-unmeasured">
        pedaggi NON misurati: {d.unmeasured.join(" · ")}
      </p>
    </div>
  );
};
